import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agreement-app-form',
  templateUrl: './agreement-app-form.component.html',
  styleUrls: ['./agreement-app-form.component.css']
})
export class AgreementAppFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/agreements-app/agreements-approval/agreement-app-form/agreement-app-form.component.ts